import { ComputedRef, InjectionKey, Ref } from 'vue';

import { EcosystemFieldMappings } from '@/types/integration_profiles';

export const ProvidedIsIntegrationEnabled: InjectionKey<Ref<boolean>> = Symbol(
  'isIntegrationEnabled',
);

export const ProvidedIsAccountObjectPushEnabled: InjectionKey<
  ComputedRef<boolean>
> = Symbol('isAccountObjectPushEnabled');

type EcosystemFields = {
  ecosystemFieldMappings: Ref<EcosystemFieldMappings>;
  updateEcosystemFieldMappings: (
    ecosystemFieldMappings: EcosystemFieldMappings,
  ) => void;
};
export const ProvidedEcosystemFields: InjectionKey<EcosystemFields> =
  Symbol('EcosystemFields');
